
import { StakeBet } from "../../../../scripts/StakeBet";

class VideoPokerBet extends StakeBet{
    constructor(betData = {}){
        super('videopoker')
        this.data = {... this.data, ... betData}
        this.betStrategy = { fnc: () => { return {} }, details: { } }

        this.nSteps = 0
    }

    async runStrategy( betStrategy, betConfig  ) {
   
        if(betStrategy)
            this.betStrategy = betStrategy
        
        if (betConfig)
            this.betConfig = {... this.betConfig, ... betConfig}
        
        if(!this.betStrategy?.fnc)
            return [{message: "no bet strategy function"}, null]
      
        if(typeof this.betStrategy?.fnc === 'function' ){
            try {
                if(!this.data?.id)
                    await this.bet(this.betConfig)

                const { variables , details } = this.betStrategy.fnc(this.data, {... this.betStrategy?.details })
                //let variables = (queryVars) ? queryVars : {} 

                let [error,result] = await this.next(variables)
                if(error)
                    throw error

                this.betStrategy.details = { ... this.betStrategy.details, ... {details} }
            } catch (error) {
                console.log("[ERROR] VideoPoker runStrategy,  this.betStrategy function error")
                return [error, null]
            }
        }
        
        return [null, this.data]

    }
    async next(variables = {}){

        let [err, result] = await this.step("next", variables)

        return [err,  this.data]
    }

    async bet(betConfig){
        if(betConfig)
         this.betConfig =  {... this.betConfig, ... betConfig }

        let [err, result] = await this.step("bet", this.betConfig)

        return [ err, this.data]
    }

    
    async step(action, variables = {}){
        try {
        
        if(super[action] && typeof super[action] === "function"){
            let step_result = await super[action](variables)

            this.nSteps++
            
            if(!this.data?.active)
                this.done(this.data)

            return [step_result.errors, step_result.data]         
        }

        }
        catch(err){
        console.log("[err] VideoPokerBet fnc step: ")
        console.error(err)
        return [err, null]
        }

    }

    done(betResult){
        if(this._resultResolve)
        this._resultResolve(betResult)
    }

    result(){
        return new Promise((resolve,reject) =>{
        this._resultResolve = resolve
        this._resultReject = reject

        })
    }
}

export { VideoPokerBet }


const VideoPokerStrategies = {

    "fourOfKind": {
        fnc: (bet, details) => { 
                let hand = bet.state.initialHand
                //hold all cards matching details.rank
                let held = hand.filter( card => card.rank == details?.rank ? true : false)
                return {variables: {held: held}, details}
           },
           details: {
               rank: "4"
           }
    }

}

export { VideoPokerStrategies }